
// Basic definitions for the alert engine

// --- Alert Definitions ---

// 1. SOS Alert (High Priority)
export const SOS_ALERT_DEF = {
    id: 'SOS',
    severity: 'is-danger',
    label: 'SOS Signal',
    priority: 100,
    isSticky: true, // SOS stays until confirmed
    predicate: (device) => {
        // Check raw attributes for SOS signal
        const val = device.attributes?.sos;
        const carStatus = device.attributes?.CarStatus;
        return val === true || val === 'true' || carStatus === 'SOS';
    },
    messageBuilder: (device) => {
        const name = device.deviceName || device.deviceId || 'Unknown Device';
        return `SOS: Device ${name} sent SOS signal!`;
    }
};

// 2. OK Alert (Medium-High Priority)
export const OK_ALERT_DEF = {
    id: 'OK',
    severity: 'is-success',
    label: 'OK Signal',
    priority: 80,
    isSticky: false, // Auto-clears when CarStatus is no longer 'OK', re-fires on next trigger
    predicate: (device) => {
        return device.attributes?.CarStatus === 'OK';
    },
    messageBuilder: (device) => {
        const name = device.deviceName || device.deviceId || 'Unknown Device';
        return `OK: Device ${name} sent OK signal. All clear.`;
    }
};

// 3. Stopped > 10s Alert (Medium Priority)
// Note: Ideally 'stoppedSince' is calculated before this check in the enrichment phase
export const STOP_ALERT_DEF = {
    id: 'STOP_10S',
    severity: 'is-warning',
    label: 'Stopped > 10s',
    priority: 50,
    isSticky: false, // Auto-clears if moving again
    predicate: (device) => {
        if (!device.stoppedSince) return false;
        // Logic: if stopped for more than 10 seconds
        const elapsed = Date.now() - device.stoppedSince;
        return elapsed >= 10000;
    },
    messageBuilder: (device) => {
        const name = device.deviceName || device.deviceId || 'Unknown Device';
        return `Device ${name} stopped > 10s`;
    }
};

// 4. Off-Track Exit Alert (car left the stage before finishing it)
export const OFF_TRACK_EXIT_ALERT_DEF = {
    id: 'OFF_TRACK_EXIT',
    severity: 'is-warning',
    label: 'Off-Track Exit',
    priority: 75,
    isSticky: true, // stays until acknowledged — car may need assistance
    predicate: (device) => device.exitedMidStage === true,
    messageBuilder: (device) => {
        const name = device.deviceName || device.deviceId || 'Unknown Device';
        const dist = device.lastDistanceOnStage_m > 0
            ? ` at ${(device.lastDistanceOnStage_m / 1000).toFixed(2)} km`
            : '';
        return `Car ${name} left the stage off-track${dist}`;
    }
};

export const ALL_ALERTS = [
    SOS_ALERT_DEF,
    OK_ALERT_DEF,
    STOP_ALERT_DEF,
    OFF_TRACK_EXIT_ALERT_DEF,
];
